import { FooterLayout, FooterSignalProps } from '@eventbrite/timed-entry';
import React, { FC } from 'react';
import { DiscountSvg } from '../../assests/DiscountSvg';
import { color_mood_mellow_mellow_yellow_300 } from '../../colorContants';
import styles from '../TimeSlotContainer.module.scss';

interface DiscountFooterProps {
    discount: string;
}

const DiscountFooter: FC<DiscountFooterProps> = ({ discount }) => {
    const footerSignals: FooterSignalProps[] = [
        {
            icon: <DiscountSvg />,
            backgroundColor: color_mood_mellow_mellow_yellow_300,
            text: discount,
        },
    ];

    return (
        <div className={styles.discountWrapper} data-testid="overall-discount">
            <FooterLayout footerMetaData={footerSignals} />
        </div>
    );
};

export default DiscountFooter;
